import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle, LogOut, Mail } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

interface UserAccessBlockedScreenProps {
  reason?: 'user_limit_exceeded' | 'no_subscription' | 'blocked';
  message?: string;
}

export const UserAccessBlockedScreen = ({ reason, message }: UserAccessBlockedScreenProps) => {
  const { signOut, user } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    window.location.href = '/auth';
  };

  const getTitle = () => {
    switch (reason) {
      case 'user_limit_exceeded':
        return 'Limite de Usuários Excedido';
      case 'no_subscription':
        return 'Assinatura Inativa';
      case 'blocked':
        return 'Acesso Bloqueado';
      default:
        return 'Acesso Restrito';
    }
  };

  const getDescription = () => {
    if (message) return message;
    
    switch (reason) {
      case 'user_limit_exceeded':
        return 'O número máximo de usuários permitidos para esta conta foi atingido. Entre em contato com o administrador da conta para liberar seu acesso ou adquirir usuários adicionais.';
      case 'no_subscription':
        return 'A assinatura desta conta está inativa. O administrador precisa renovar a assinatura para que você possa acessar o sistema.';
      case 'blocked':
        return 'Seu acesso foi bloqueado. Entre em contato com o administrador para mais informações.';
      default:
        return 'Você não tem permissão para acessar o sistema no momento.';
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle className="w-8 h-8 text-destructive" />
          </div>
          <CardTitle className="text-xl">{getTitle()}</CardTitle>
          <CardDescription className="text-base">
            {getDescription()}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-muted rounded-lg p-4 text-sm">
            <p className="text-muted-foreground">
              <strong>Conta:</strong> {user?.email}
            </p>
          </div>
          
          <div className="flex flex-col gap-3">
            <Button variant="outline" className="w-full" asChild>
              <a href="mailto:suporte@workia.com.br">
                <Mail className="w-4 h-4 mr-2" />
                Contatar Suporte
              </a>
            </Button>
            
            <Button variant="ghost" className="w-full" onClick={handleSignOut}>
              <LogOut className="w-4 h-4 mr-2" />
              Sair e usar outra conta
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
